var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-full items-center"},[_c('div',{staticClass:"flex justify-center items-center cstm-status-badge w-full",class:_vm.params.data.process_success_status.toLowerCase(),staticStyle:{"margin":"0","padding":"0","height":"38px","font-size":"13px"}},[_vm._v("\n    "+_vm._s(_vm.params.data.process_success_status)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }